import { render } from "./Tags.vue?vue&type=template&id=ee2938be"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=ee2938be&lang=css"
script.render = render

export default script